import { render } from "./ErrorPopup.vue?vue&type=template&id=671e58d6"
import script from "./ErrorPopup.vue?vue&type=script&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&lang=js"

import "./ErrorPopup.vue?vue&type=style&index=0&id=671e58d6&lang=scss"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__